import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { Router } from '@angular/router';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';
import { retry } from 'rxjs/operators';
declare var $: any;
import { ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-candidatesdetails',
  templateUrl: './candidatesdetails.component.html',
  styleUrls: ['./candidatesdetails.component.scss']
})
export class CandidatesdetailsComponent {
    pjobdata: any;
    Selectjobdata: any;
    Sjobdata: any;
    jobdata: any;
    Rejectjobdata: any;
    Rjobdata: any;
    HomeURL: any;
    PID: any;
    loginDet: any;
    loginDetails: any;
    selectedTab: any;
    ProfileImage: any;
    constructor(private elementRef: ElementRef, private renderer: Renderer2, public generalService: GeneralService,
        private http: HttpClient, private fb: FormBuilder, public Rm: ReactiveFormsModule,
        public router: Router, public route: ActivatedRoute) {
        debugger
        this.PID = this.route.snapshot.paramMap.get("PID");
        this.loginDet = localStorage.getItem("LoginDetails");
        this.loginDetails = JSON.parse(this.loginDet)
        this.selectedTab = localStorage.getItem('selectedTab') || 'tab1';
        

        console.log('pid', this.PID)

        this.ProfileImage = this.loginDetails.Companylogo || '';
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeURL = data.Webservice;

        });
        


    }

    ngOnInit() {
        
        this.Getpendingjob();
        this.Getrejectjob();
        this.Getselectjob();

        this.route.queryParams.subscribe(params => {
            if (params['tab']) {
                this.selecttab = params['tab'];
            }
        });
    }

    jobtab: string = 'Postjobs'; // Set default tab to 'companyDetail'
    currentTab: string = 'companyDetail'; // Set default tab to 'companyDetail'
    selecttab: string = 'pendingDetail'; // Set default tab to 'selectedDetail'

    //switchjobs(tabName: string): void {
    //    debugger
    //    this.jobtab = tabName;
    //    this.Companyjobs();
    //}
    switchTab(tabName: string): void {
        this.currentTab = tabName; // Change the active tab
    }
    switchTab1(tab: string) {
        this.selecttab = tab;
    }


    Getpendingjob() {
        debugger

        var uploadfile = new FormData();
        uploadfile.append("Param1", this.loginDetails[0].RID);
        var url = "api/Njobs/NJ_Get_JobApplyDetailsBasedonCompanyId";
        this.generalService.PostData(url, uploadfile).then(data => {
            debugger
            this.pjobdata = data;

            this.jobdata = this.pjobdata.filter(item => item.ActionStatus === 1 || item.ActionStatus === 4);
        })
    }

    Getselectjob() {
        debugger
        var uploadfile = new FormData();
        uploadfile.append("Param1", this.loginDetails[0].RID);
        var url = "api/Njobs/NJ_Get_JobApplyDetailsBasedonCompanyId";
        this.generalService.PostData(url, uploadfile).then(data => {
            debugger
            this.Selectjobdata = data;
            this.Sjobdata = this.Selectjobdata.filter(item => item.ActionStatus === 2 || item.ActionStatus === 4);

        })
    }
    Getrejectjob() {
        debugger
        var uploadfile = new FormData();
        uploadfile.append("Param1", this.loginDetails[0].RID);
        var url = "api/Njobs/NJ_Get_JobApplyDetailsBasedonCompanyId";
        this.generalService.PostData(url, uploadfile).then(data => {
            debugger
            this.Rejectjobdata = data;
            this.Rjobdata = this.Rejectjobdata.filter(item => item.ActionStatus === 3 || item.ActionStatus === 4);

        })
    }

    downloadResume(fileName: string, event: any) {
        debugger
        this.Updatestatusview(event.JID)
        const pdfUrl = this.HomeURL + event.Resume;  // Path to the PDF file

        // Open PDF in a new tab (to view the PDF)
        window.open(pdfUrl, '_blank');

        // Download PDF (prompt download)

    }
    Updatestatusview(JID) {
        debugger
        var uploadfile = new FormData();
        uploadfile.append('Param1', JID);
        uploadfile.append('Param2', '4');
        var url = "api/Njobs/NJ_UpdateStatus";
        this.generalService.PostData(url, uploadfile).then((data: any) => {

        });
    }
    UpdatestatusSelect(candidate) {
        debugger
        var uploadfile = new FormData();
        uploadfile.append('Param1', candidate.JID);
        uploadfile.append('Param2', '2');
        var url = "api/Njobs/NJ_UpdateStatus";
        this.generalService.PostData(url, uploadfile).then((data: any) => {
            if (data === 'SUCCESS') {

                this.generalService.ShowAlert("SUCCESS", 'Selected candidate successfully.', 'success');
                window.location.reload();
            } else {

                this.generalService.ShowAlert("ERROR", 'Failed to update status for the selected candidate.', 'error');
            }
        }).catch(err => {

            this.generalService.ShowAlert("ERROR", 'Something went wrong while updating the status.', 'error');
        });
    }



    UpdatestatusReject(candidate) {
        debugger
        var uploadfile = new FormData();
        uploadfile.append('Param1', candidate.JID);
        uploadfile.append('Param2', '3');
        var url = "api/Njobs/NJ_UpdateStatus";
        this.generalService.PostData(url, uploadfile).then((data: any) => {
            if (data === 'SUCCESS') {
                // Show a success alert message
                this.generalService.ShowAlert("SUCCESS", 'Rejected candidate successfully.', 'success');
                window.location.reload();
            }
        });
    }
    playAudio(audioUrl: any) {
        const audioPath = this.HomeURL + audioUrl.AudioRecord;

        // Open a new tab
        const newTab = window.open(audioPath, '_blank');

        if (newTab) {
            // Inject an HTML audio element to play in the new tab
            newTab.document.write(`
            <html>
                <head><title>Audio Playback</title></head>
                <body style="margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; height: 100vh;">
                    <audio controls autoplay style="width: 30%;">
                        <source src="${audioPath}" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>
                </body>
            </html>
        `);

            newTab.document.close();
        } else {
            console.error('Failed to open new tab for audio playback');
        }
    }


    // Function to play video in a new window or tab
    playVideo(videoUrl: any) {

        // Combine the base URL and the video record path to form the full video URL
        const videolink = this.HomeURL + videoUrl.VideoRecord;

        // Check if the video URL is valid (i.e., non-empty and properly formed)
        if (videolink && videolink.trim() !== '') {
            // Create a new window or tab
            const newTab = window.open('', '_blank');

            if (newTab) {
                // Create the HTML content to embed the video in the new tab
                newTab.document.write(`
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Video Player</title>
                </head>
                <body>
                    <video controls autoplay style="width: 40%; height: auto;">
                        <source src="${videolink}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </body>
                </html>
            `);
                newTab.document.close();  // Close the document after writing
            }
        } else {
            console.error('Invalid video URL:', videolink);
        }
    }
    DeleteCadidates(JID) {
        debugger;
        Swal.fire({
            title: 'Alert',
            text: 'Are you sure to delete this Candidate ?',
            showCancelButton: true,
            //icon: 'warning',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((data1) => {
            if (data1.value == true) {

                var UploadFile = new FormData();
                UploadFile.append('Param1', JID);

                var url = "api/Njobs/Delete_AppliedJobs_basedonJID";
                this.generalService.PostData(url, UploadFile).then((data: any) => {
                    debugger
                    if (data === 'SUCCESS') {
                        this.generalService.ShowAlert("SUCCESS", 'Candidate Deleted Successfully', 'success');
                        window.location.reload();
                    } else {
                        this.generalService.ShowAlert("ERROR", 'Something went wrong', 'error');
                    }
                });
            }
        });
    }

    download(pdfpath: string | null): void {
        debugger
        console.log('Download clicked:', pdfpath); // Log to check if the function is called
        if (pdfpath) {
            const absoluteUrl: string = `http://localhost:4200/${pdfpath}`;
            console.log('Absolute URL:', absoluteUrl); // Log the constructed URL

            const link = document.createElement('a');
            link.href = absoluteUrl;
            link.setAttribute('download', `resume_${new Date().getTime()}.pdf`);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('File path not available');
        }
    }



    download1(pdfpath: string | null): void {
        if (pdfpath) {
            const timestamp = new Date().getTime(); // Get current timestamp
            const absoluteUrl: string = `https://letshelp.breakingindiaapp.com/Webservices/${pdfpath}?t=${timestamp}`;

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = absoluteUrl;

            // Set the download attribute to specify the filename or leave it empty for automatic handling
            const fileName = pdfpath.split('/').pop(); // Get the file name from the path
            link.setAttribute('download', fileName || 'downloaded_file.pdf');

            // Append link to the body
            document.body.appendChild(link);

            // Programmatically click the link to trigger the download
            link.click();

            // Remove the anchor element from the DOM
            document.body.removeChild(link);
        } else {
            console.error('File path is not available');
        }
    }





    downloadFile(filePath: string): void {
        debugger
        const absoluteUrl: string = `https://letshelp.breakingindiaapp.com/Webservices/${filePath}`;

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = absoluteUrl;
        link.setAttribute('download', ''); // This will set the download attribute to force download
        document.body.appendChild(link);

        // Simulate a click on the anchor element
        link.click();

        // Remove the anchor element from the DOM
        document.body.removeChild(link);
    }
}
